import 'animate.css'
import { AppReducerBase, PersistType, RouteGf, RoutesGf, WebContainer } from 'gf-ui'
import { lazy, useMemo, useState } from 'react'
import imgLogin from './assets/images/immagine_home.jpg'
import "./assets/sass/App.scss"
import Credits from './pages/Credits'
import { apiReducer } from './reducer/slice/apiSlice'
import {ROUTES_GF_DEFAULT_PROPS} from "gf-ui";
import { WebContext } from "./WebContext"
const Home = lazy(() => import('./pages/Home'))
const NuovaRichiesta = lazy(() => import('./pages/richiesta/NuovaRichiesta'))

const routesProps = {    
  ...ROUTES_GF_DEFAULT_PROPS,
  profiliUtenti: {
    ...ROUTES_GF_DEFAULT_PROPS.profiliUtenti,
    insertRoutes: false
  }
}

const App = () => {
  const [showHomeItem, toggleHomeItem] = useState(false)

  const reducer = useMemo(() => {
    const reducer = new AppReducerBase();
    reducer.addReducer("api", apiReducer, PersistType.SESSION)
    return reducer
  }, [])

  const routes = useMemo(() => {
    const routes = new RoutesGf(routesProps);
    /*--------------------------------------------Home---------------------------------------------------*/
    routes.addRoute(new RouteGf("/", "home", <Home />))
    /*------------------------------------------Richiesta------------------------------------------------*/
    routes.addRoute(new RouteGf("/richiesta", "richiesta", <NuovaRichiesta />))

    return routes;
  }, [])

  return (
    <div className="App vh-100 bg-light">
      <WebContext.Provider value={{ toggleHomeItem: toggleHomeItem }}>
        <WebContainer
          className="vh-100"
          imgLogin={imgLogin}
          imgCredits={<><a href="https://www.freepik.com/free-vector/tiny-professional-business-people-carrying-upward-arrow_19216949.htm#fromView=search&page=1&position=6&uuid=5ea9f18a-07ce-4b78-9457-b78b1b0162bb" target="_blank" rel="noreferrer">Image by pch.vector on Freepik</a></>}
          reducer={reducer}
          moduloRoutes={routes}
          credits={<Credits />}
          showMenuSidebar={true}
          showHeader={true}
          bgLogin="#07549d"
          showEditProfileBtn={false}
          logoEnte={`${process.env.REACT_APP_BASE_URL_PROD}${process.env.REACT_APP_BE_NAME}/images/layout/logoAlboFornitoriEnte.jpg`}
          showSidebar={false}
          showHomeItem={showHomeItem}
        />
      </WebContext.Provider>
    </div>
  )
}
export default App;
